import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { DeXuatNhuCauTaiSan, DeXuatNhuCauTaiSanRequest } from "../models/taisan/DeXuatNhuCauTaiSan";
import intance from "../utils/axios";

export const layDSDexuatNhuCau = async (idDonVi?: number, loaiNhuCau?: number, trangThai?: number) => {
    var data: DeXuatNhuCauTaiSan[] = [];
    const params = new URLSearchParams();
    if (idDonVi) params.append('idDonVi', idDonVi.toString());
    if (loaiNhuCau) params.append('loaiNhuCau', loaiNhuCau.toString());
    if (trangThai !== undefined && trangThai !== null) params.append('trangThai', trangThai.toString());
    
    await intance.get(`${ApiPaths.deXuatNhuCauTaiSan.layDS}?${params.toString()}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu || [];
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layChiTietDeXuat = async (id: number) => {
    var rs: DeXuatNhuCauTaiSan | null = null;
    await intance.get(`${ApiPaths.deXuatNhuCauTaiSan.layChiTiet}?id=${id}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuDeXuat = async (request: DeXuatNhuCauTaiSan) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.deXuatNhuCauTaiSan.luu, request)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const trinhDuyetDeXuat = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.deXuatNhuCauTaiSan.trinhDuyet, { id })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const thuHoiDeXuat = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.deXuatNhuCauTaiSan.thuHoi, { id })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const pheDuyetDeXuat = async (id: number, lyDo?: string) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.deXuatNhuCauTaiSan.pheDuyet, { id, lyDo })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const chuyenCVVPDeXuat = async (id: number, idCVVP: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.deXuatNhuCauTaiSan.chuyenCVVP, { id, idCVVP })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const tuChoiDeXuat = async (id: number, lyDo: string) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.deXuatNhuCauTaiSan.tuChoi, { id, lyDo })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const trinhThamMuuDeXuat = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.deXuatNhuCauTaiSan.trinhThamMuu, { id })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const luuFileInDeXuat = async (id: number, file: File) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    const formData = new FormData();
    formData.append("id", id.toString());
    formData.append("file", file);
    await intance.post(ApiPaths.deXuatNhuCauTaiSan.luuFileIn, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};
